export default __webpack_public_path__ + "static/media/scooterr.6ea15ce1.png";